<div class="card shadow-sm mb-3">
  <div class="card-header d-flex justify-content-between align-items-center" (click)="toggleCardBody()">
    <h3 class="card-title">Campaigns</h3>
    <i class="fa ms-auto" [ngClass]="{'fa-arrow-down': isCollapsed, 'fa-arrow-up ': !isCollapsed}"></i>
  </div>
  <div class="card-body" [hidden]="isCollapsed">
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Name</th>
          <th>Discount</th>
          <th>From</th>
          <th>To</th>
        </tr>
      </thead>
      <tbody>
        @for (campaign of campaigns; track campaign) {
          <tr>
            <td>{{ campaign.name }}</td>
            <td>{{ campaign.discountPercent }}%</td>
            <td>{{ campaign.startTime }}</td>
            <td>{{ campaign.endTime }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
